export default "__VITE_ASSET__39cb9bd0__"